import { mapFields } from 'vuex-map-fields'

export default {
  computed: {
    ...mapFields('reports', ['dateInterval']),
    isInss () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'inss' && this.tenant === 'inss'
      }
      return false
    },
    isSefMg () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'sefmg' && this.tenant === 'sefmg'
      }
      return false
    },
    isDataPrev () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'dataprev' && this.tenant === 'dataprev'
      }
      return false
    },
    isYara () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'yara'
      }
      return false
    },
    isYaraLtm () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'yaraltm' && this.tenant === 'yaraltm'
      }
      return false
    },
    isRegularize () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'regularize' && this.tenant === 'regularize'
      }
      return false
    },
    isDemo () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'demo' && this.tenant === 'demo'
      }
      return false
    },
    isIma () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'ima' && this.tenant === 'ima'
      } else if (currentUrl.includes('rocketchat')) {
        return false
      }
      return true
    },
    isIpmc () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'ipmc' && this.tenant === 'ipmc'
      } else if (currentUrl.includes('rocketchat')) {
        return this.tenant === 'ipmc'
      }
      return false
    },
    isSesam () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !currentUrl.includes('rocketchat')) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'sesam' && this.tenant === 'sesam'
      }
      return false
    },
    isCedae () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'cedae' && this.tenant === 'cedae'
      }
      return false
    },
    isDanese () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'danese' && this.tenant === 'danese'
      }
      return false
    },
    isEds () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'eds' && this.tenant === 'eds'
      }
      return false
    },
    isExtreme () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !currentUrl.includes('rocketchat')) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return result === 'extreme' && this.tenant === 'extreme'
      }
      return false
    }
  },
  created () {
    const locationHostURL = location.host
    if (locationHostURL.includes('outbound')) {
      this.env = 'prd2'
      this.tenant = 'ima'
    } else if (locationHostURL.includes('rocketchat') || locationHostURL.includes('rocket.chat')) {
      this.env = 'prd2'
      this.tenant = 'ipmc'
    } else {
      const hostSeparated = location.host.split('-')
      this.env = hostSeparated?.[0]
      this.tenant = hostSeparated?.[1]
    }
  }
}
